import { render, staticRenderFns } from "./LiquidacionList.vue?vue&type=template&id=641b6137&scoped=true&"
import script from "./LiquidacionList.vue?vue&type=script&lang=js&"
export * from "./LiquidacionList.vue?vue&type=script&lang=js&"
import style0 from "./LiquidacionList.vue?vue&type=style&index=0&id=641b6137&lang=scss&scoped=true&"
import style1 from "./LiquidacionList.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./LiquidacionList.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641b6137",
  null
  
)

export default component.exports